"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeForms_en_us = void 0;
function backofficeForms_en_us() {
    return {
        "backoffice.forms.title": "Forms",
        "backoffice.forms.subtitle": "Create custom forms which can be used in your Checkin-apps.",
        "backoffice.forms.empty.title": "No forms found...",
        "backoffice.forms.empty.meanwhile": "In the meantime you can create your own and individual forms here.",
        "backoffice.forms.empty.createform": "Create a new Form",
        "backoffice.forms.editor.requiredfields": "Customers have to fill out the following fields",
        "backoffice.forms.editor.resetform": "Reset Form",
        "backoffice.forms.tooltip.switchtranslation": "Switch translation on or off for this field",
        "backoffice.forms.tooltip.changecurrentlang": "Change current locale",
        "backoffice.forms.tooltip.addtofavorites": "Add to my favorites",
        "backoffice.forms.tooltip.removefromfavorites": "Remove from my favorites",
        "backoffice.forms.tooltip.setasafavorite": "Set as a favorite"
    };
}
exports.backofficeForms_en_us = backofficeForms_en_us;
